<template>
  <div class="col-12">
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th class="header-color text-center">STT</th>
          <th class="header-color text-center">Sản phẩm</th>
          <th scope="col" class="title-center">IMEI</th>
          <th class="header-color text-center">SL yêu cầu</th>
          <th class="header-color text-center">SL duyệt</th>
          <th class="header-color text-center">SL xác nhận</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-for="(productItem, index) in productItems" :key="index">
        <tr class="heighRow">
          <td class="text-center" style="width: 5%">
            <span class="font-weight-bolder">{{ productItem.stt }}</span>
          </td>
          <td style="width: 30%">
            <div style="display: flex; gap: 8px; align-items: center">
              <!-- Ảnh sản phẩm -->
              <ProductImage :src="productItem.productImageUrl" />

              <!-- Thông tin sản phẩm -->
              <div>
                <span style="font-size: 11px">{{ productItem.barCode }}</span>
                <br />
                <span style="font-size: 12px"
                  >({{ productItem.productCode }})</span
                >
                <br />
                <p class="m-0" style="font-weight: 500">
                  {{ productItem.productName }}
                </p>
                <p class="m-0">Tồn: {{ productItem.inStockQuantity }}</p>
              </div>
            </div>
          </td>
          <td class="px-4 stock-slip-imei-td" style="width: 25%" ref="imeiTd">
            <div
              v-if="
                editable && productItem.productType === productType.PRODUCT_IMEI
              "
            >
              <IMEIInputForm
                :productItem="productItem"
                :storeId="storeId"
                :showChoose="action === 'approve' ? true : false"
                :quantityKey="
                  action === 'approve' ? 'quantityApprove' : 'quantityConfirm'
                "
              />
            </div>
            <div v-else class="stock-slip-imei-readonly">
              {{ formatImeiListForDisplay(productItem) }}
            </div>
          </td>
          <td class="td-middle text-right" style="width: 10%">
            <div>
              {{ productItem.quantity }}
            </div>
          </td>
          <td class="td-middle text-right" style="width: 10%">
            <div
              v-if="
                action === 'approve' &&
                productItem.productType !== productType.PRODUCT_IMEI
              "
            >
              <BInputNumber
                v-model="productItem.quantityApprove"
                style="border-color: #007bff"
                placeholder="Số lượng"
                :inputClass="'w-100 text-right'"
              />
            </div>
            <div v-else>
              {{ productItem.quantityApprove || productItem.approveQuantity }}
            </div>
          </td>

          <td class="td-middle text-right" style="width: 10%">
            <div v-if="action === 'confirm'">
              <BInputNumber
                v-model="productItem.quantityConfirm"
                style="border-color: #007bff"
                placeholder="Số lượng"
                :inputClass="'w-100 text-right'"
                :disabled="
                  !editable ||
                  productItem.productType === productType.PRODUCT_IMEI
                "
              />
            </div>
            <div v-else>
              {{ productItem.quantityConfirm }}
            </div>
          </td>
          <td class="td-middle" style="width: 5%" v-if="editable">
            <div class="d-flex justify-content-center">
              <span
                style="color: #3f4254; font-size: 12px; cursor: pointer"
                @click="showDeleteAlert(productItem)"
              >
                <i
                  style="font-size: 1rem; color: #d33"
                  class="flaticon2-rubbish-bin-delete-button"
                ></i>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th style="text-align: end" colspan="3">Tổng :</th>
          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
            {{ totalByField('quantity') }}
          </td>
          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
            {{
              totalByField('quantityApprove') || totalByField('approveQuantity')
            }}
          </td>
          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
            {{ totalByField('quantityConfirm') }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';
import Swal from 'sweetalert2';
import { makeToastFaile, convertPrice } from '@/utils/common';
import _sumBy from 'lodash/sumBy';
import { PRODUCT_TYPE } from '@/utils/enum';
import ProductImage from '@/view/components/products/ProductImage.vue';
import IMEIInputForm from './IMEIInputForm.vue';
import { formatImeiListForDisplay } from '@/utils/stockSlipImeiDisplay';

export default {
  props: ['editable', 'productItems', 'action', 'storeId'],
  data() {
    return {
      productType: PRODUCT_TYPE,
      imeiTdWidth: 0,
    };
  },
  components: {
    BInputNumber,
    IMEIInputForm,
    ProductImage,
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const tdEl = this.$refs.imeiTd;
        if (tdEl) {
          this.imeiTdWidth = tdEl[0].offsetWidth;
        }
      }, 50);
    });
  },
  computed: {},
  methods: {
    convertPrice,
    formatImeiListForDisplay,
    async showDeleteAlert(product) {
      const text = `Bạn muốn xoá sản phẩm ${product.productName} ra khỏi danh sách`;
      const alert = await this.showWarningAlert(text);

      if (alert.isConfirmed) {
        const index = this.getIndexProductItems(product.id);

        if (index > -1) {
          this.productItems.splice(index, 1);
          this.numberedProductItems();
        }
      }
    },
    showWarningAlert: function (text) {
      return Swal.fire({
        title: 'Xoá sản phẩm!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    getIndexProductItems(id) {
      const index = this.productItems.findIndex((item) => item.id === id);
      if (index < 0) {
        makeToastFaile(`Không tìm thấy ${id} trong danh sách`);
        throw new Error(`Không tìm thấy ${id} trong danh sách`);
      }
      return index;
    },
    numberedProductItems() {
      let count = 1;
      return this.productItems.map((item) => {
        item.stt = count;
        count++;
        return item;
      });
    },
    enterClicked(productItem) {
      let countLine = 0;
      const tmp = productItem.IMEI.split(/\r\n|\r|\n/);
      tmp.forEach((element) => {
        if (element.trim() !== '') {
          countLine++;
        }
      });
      productItem.quantity = countLine;
    },
    onChangeDetail(productItem) {
      this.$emit('onChangeDetail', productItem);
    },
    totalByField(fieldName) {
      return _sumBy(this.productItems, fieldName);
    },
  },
};
</script>

<style scoped>
.stock-slip-imei-td {
  vertical-align: top;
}
.stock-slip-imei-readonly {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  max-width: 100%;
  max-height: 220px;
  overflow-y: auto;
  font-size: 12px;
  line-height: 1.35;
}
</style>
